import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './TrackOrder.css';
import axios from 'axios';
import Navbar from '../Navbar';
import Navbar2 from '../Navbar2';
import { FaBox, FaCheck, FaCreditCard, FaHome, FaMapMarkerAlt, FaPhone, FaShippingFast } from 'react-icons/fa';
import Footer from '../Footer/Footer';



const statusConfig = [
    { id: 'Order Placed', label: 'Order Placed', description: 'Your order has been received', icon: <FaBox className="status-icon" /> },
    { id: 'Dispatched', label: 'Dispatched', description: 'Your order has left our warehouse', icon: <FaShippingFast className="status-icon" /> },
    { id: 'In Transit', label: 'In Transit', description: 'Your order is on its way', icon: <FaShippingFast className="status-icon" /> },
    { id: 'Out for Delivery', label: 'Out for Delivery', description: 'Your order will arrive soon', icon: <FaShippingFast className="status-icon" /> },
    { id: 'Delivered', label: 'Delivered', description: 'Your order has arrived', icon: <FaCheck className="status-icon" /> }
];


function TrackOrder() {

    const { state } = useLocation();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const navigate = useNavigate();



    useEffect(() => {
        const fetchOrders = async () => {
            try {
                setLoading(true);
                setError(null);

                if (state?.orderId) {
                    // Fetch single order
                    const { data } = await axios.get(
                        `http://localhost:3001/orders/${state.orderId}`,
                        { withCredentials: true }
                    );
                    setSelectedOrder(data);
                } else {
                    // Fetch all orders
                    const { data } = await axios.get(
                        'http://localhost:3001/orders/my-orders',
                        { withCredentials: true }
                    );
                    setOrder(data || []); // Ensure it's always an array
                }
            } catch (error) {
                // console.error("Failed to fetch orders:", error);
                setError(error.response?.data?.error || "Failed to load order details");
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [state?.orderId]);

    if (loading) return <div className="loading-container">Loading...</div>;

    if (error) return (
        <div className="error-container">
            <p>{error}</p>
            <button onClick={() => window.location.reload()}>Try Again</button>
        </div>
    );


    if (selectedOrder) {
        return renderSingleOrder(selectedOrder);
    }


    // Render list of orders if no specific order is selected


    return (
        <div className="track-order-page">
            <Navbar />
            <div className="sticky-navbar">
                <Navbar2 />
            </div>

            <div className="orders-list-container">
                <h2>Your Orders</h2>

                {order.length === 0 ? (
                    <div className="no-orders">
                        <p>You haven't placed any orders yet.</p>
                        <button className="shop-now-btn" onClick={() => navigate('/home')}>
                            Shop Now
                        </button>
                    </div>
                ) : (
                    <div className="orders-grid">
                        {order.map(order => (
                            <div key={order._id} className="order-card" onClick={() => setSelectedOrder(order)}>
                                <div className="order-header">
                                    <span className="order-id">Order #{order._id.slice(-8).toUpperCase()}</span>
                                    <span className={`status-badge ${order.trackingStatus.toLowerCase().replace(' ', '-')}`}>
                                        {order.trackingStatus}
                                    </span>
                                </div>
                                <div className="order-date">
                                    {new Date(order.createdAt).toLocaleDateString()}
                                </div>
                                <div className="order-total">
                                    ₹{order.total.toFixed(2)}
                                </div>
                                <div className="order-items-preview">
                                    {order.items.slice(0, 3).map((item, index) => {
                                        const productId = item._id || item.productId;
                                        if (!productId) {
                                            console.error("Missing product ID in item:", item);
                                            return null;
                                        }
                                        return (
                                            <div
                                                key={index}
                                                className="order-item-preview"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate(`/product/${productId}`);
                                                }}
                                            >
                                                <img
                                                    src={item.image}
                                                    alt={item.name}
                                                    className="item-thumbnail"
                                                />
                                                <span className="item-name">{item.name}</span>
                                                <span className="item-price">₹{item.price}</span>
                                            </div>
                                        )
                                    }
                                    )}
                                    {order.items.length > 3 && (
                                        <div className="more-items">+{order.items.length - 3} more</div>
                                    )}
                                </div>
                                <button
                                    className="view-details-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedOrder(order);
                                    }}
                                >
                                    Track Order
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <Footer/>
        </div>
    );



    function renderSingleOrder(order) {
        const currentStatusIndex = statusConfig.findIndex(s => s.id === order.trackingStatus);

        return (
            <div className="track-order-page">
                <Navbar />
                <div className="sticky-navbar">
                    <Navbar2 />
                </div>

                <div className="track-order-container">
                    <div className="order-header">
                        {/* <button
                            className="back-to-orders"
                            onClick={() => setSelectedOrder(null)}
                        >
                            &larr; Back to All Orders
                        </button> */}
                        <h2>Track Your Order</h2>
                        <div className="order-id-badge">Order #{order._id.slice(-8).toUpperCase()}</div>
                    </div>

                    <div className="order-summary-card">
                        <div className="summary-item">
                            <span className="summary-label">Ordered By:</span>
                            <span>{order.userName}</span>
                        </div>
                        <div className="summary-item">
                            <span className="summary-label">Status:</span>
                            <span className={`status-badge ${order.trackingStatus.toLowerCase().replace(' ', '-')}`}>
                                {order.trackingStatus}
                            </span>
                        </div>
                        <div className="summary-item">
                            <span className="summary-label">Last Updated:</span>
                            <span>{new Date(order.updatedAt || order.createdAt).toLocaleString()}</span>
                        </div>
                        <div className="summary-item">
                            <span className="summary-label">Total Amount:</span>
                            <span className="order-total">₹{order.total.toFixed(2)}</span>
                        </div>
                    </div>

                    <div className="tracking-progress-container">
                        <h3 className="section-title">Delivery Progress</h3>
                        <div className="tracking-progress">
                            {statusConfig.map((status, index) => (
                                <div
                                    key={status.id}
                                    className={`status-step ${index <= currentStatusIndex ? 'completed' : ''} ${index === currentStatusIndex ? 'current' : ''}`}
                                >
                                    <div className="step-indicator">
                                        {index <= currentStatusIndex ? (
                                            <div className="checkmark">✓</div>
                                        ) : (
                                            <div className="step-number">{index + 1}</div>
                                        )}
                                        {status.icon}
                                    </div>
                                    <div className="step-details">
                                        <h4>{status.label}</h4>
                                        <p>{status.description}</p>
                                        {index === currentStatusIndex && order.updatedAt && (
                                            <p className="status-time">
                                                {new Date(order.updatedAt).toLocaleString()}
                                            </p>
                                        )}
                                    </div>
                                    {index < statusConfig.length - 1 && (
                                        <div className={`step-connector ${index < currentStatusIndex ? 'completed' : ''}`}></div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="details-grid">
                        <div className="order-details-card">
                            <h3 className="section-title">
                                <FaCreditCard className="section-icon" /> Payment Details
                            </h3>
                            <div className="detail-item">
                                <span className="detail-label">Method:</span>
                                <span>{order.paymentMethod}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Status:</span>
                                <span className={`payment-status ${order.paymentStatus.toLowerCase()}`}>
                                    {order.paymentStatus}
                                </span>
                            </div>
                        </div>

                        <div className="shipping-details-card">
                            <h3 className="section-title">
                                <FaMapMarkerAlt className="section-icon" /> Shipping Information
                            </h3>
                            <div className="detail-item">
                                <span className="detail-label"><FaHome /> Name:</span>
                                <span>{order.shippingAddress.name}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label"><FaMapMarkerAlt /> Address:</span>
                                <span>{order.shippingAddress.address}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">City/State:</span>
                                <span>{order.shippingAddress.city}, {order.shippingAddress.state} - {order.shippingAddress.pincode}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label"><FaPhone /> Phone:</span>
                                <span>{order.shippingAddress.phone}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="order-items-section">
                    <h3>Your Order Items</h3>
                </div>
            </div>
        );
    }

}


export default TrackOrder